import axios, { AxiosRequestConfig } from 'axios';
import { signOut } from './authService';

let apiBaseUrl: string;

const configPromise = (async () => {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error('Failed to load config');
  }
  const config = await response.json();
  apiBaseUrl = config.apiBaseUrl;
})();

export const apiRequest = async <T>(config: AxiosRequestConfig): Promise<T> => {
  try {
    await configPromise;
    const idToken = sessionStorage.getItem('idToken');
    
    if (!idToken) {
      handleUnauthorized();
      throw new Error('Not authorized');
    }

    const response = await axios({
      ...config,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
        ...config.headers,
      },
      withCredentials: false,
      baseURL: apiBaseUrl,
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 401) {
      handleUnauthorized();
    }
    throw error;
  }
};

const handleUnauthorized = async () => {
  await signOut();
  window.location.href = '/sign-in';
};